import {
  Component,
  ElementRef,
  Renderer2,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { PONodeComponent } from '../abstract-classes/po-node/ponode.component';
import { ProductNodeComponent } from '../product-node/product-node.component';
import { DetailScreensService } from '../detail-screens-module/services/detail-screens-service';
import { DomService } from '../../../services/dom-service/dom.service';
import { ProductOverviewService } from '../../../services/product-overview/product-overview.service';
import { ArrangementNodeComponent } from '../arrangement-node/arrangement-node.component';
import { UiHelperService } from '../../../services/shared/helpers/ui-helper.service';
import { PopupService } from '../popup-component/popup.service/popup.service';

@Component({
  selector: 'app-sub-category-node',
  templateUrl: '../abstract-classes/po-node/ponode.component.html',
  styleUrls: ['../abstract-classes/po-node/ponode.component.css','./sub-category-node.component.css'],
})
export class SubCategoryNodeComponent extends PONodeComponent {

  nodeType = 'sub-category-node';
  expanded = true;
  notExpandable: HTMLElement;

  constructor(domService: DomService,
              productOverviewService: ProductOverviewService,
              el: ElementRef,
              renderer: Renderer2,
              changeRef: ChangeDetectorRef,
              detailsScreenService: DetailScreensService,
              private readonly uiHelperService: UiHelperService,
              popupService: PopupService) {
    super(domService, detailsScreenService, changeRef, el, renderer, productOverviewService, popupService, uiHelperService);
  }

  initializeComponents() {
    this.hierarchyChildren.forEach((child) => {
      this.determineChildComponentType(child, ProductNodeComponent);
      if (this.childComponentType !== ArrangementNodeComponent) {
        this.children.push(this.createComponent(child, this.childComponentType));
      }
    });
    if (this.listOfArrangementsToCreate.length !== 0) {
      this.createArrangements().forEach((arrangement) => {
        this.children.push(arrangement);
      });
    }
    const numberOfChildren = this.children.length;
    if (numberOfChildren > 0) {
      this.children[numberOfChildren - 1].isLastChild = true;
      this.changeRef.detectChanges();
      this.children.forEach((child) => {
        if (child.nodeType !== 'expired-node' && child.nodeType !== 'more-node' && child.expandable && child.hierarchyChildren.length !== 0) {
          child.initializeComponents();
        } else {
          child.expanded = false;
        }
        this.changeRef.detectChanges();
      });
    }
    if (this.uiHelperService.prodClusterName !== '') {
      this.expanded = true;
    }
  }

  determineChildComponentType(child, defaultComponentType) {
    if (this.childIsArrangement(child)) {
      this.childComponentType = ArrangementNodeComponent;
      this.listOfArrangementsToCreate.push(child);
    } else if (this.childHasArrangements(child)) {
      this.childComponentType = ProductNodeComponent;
    } else {
      this.childComponentType = defaultComponentType;
    }
  }

}
